import ProposalAgreement from '../components/ProposalAgreement';

export default function DemoLanding() {
  return <ProposalAgreement mode="demo" />;
}
